// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"37cd0952","391":"332885f8","561":"392a0dad","595":"31d6cfe0","616":"f4848c5e","933":"8d2d1aa7"}[chunkId] + ".chunk.css";
};